module.exports = __webpack_public_path__ + "static/media/Layer 2.f4db1cfc.svg";